import { programData } from './program.model'; // Program靜態設定檔

// 平台架構作業
export const dwProgramInfoJson = [
  ...programData
];
